<div id="side-menu">
  <div class="side-menu-top">
    <img class="logo" src="assets/images/logo-unagro.png" />
  </div>

  <div class="side-menu-user">
    <img class="profile-pic" src="assets/images/profile-placeholder.jpg" />

    <h1>{{getUserFullName()}}</h1>
    <p>{{getUserRole()}} | <b>Legajo: </b>{{getUserLegajo()}}</p>
  </div>

  <div class="side-menu-options">
    <div class="row">

      <div class="col">
        <mat-icon matBadge="{{unreadNotifications}}"
          matBadgeHidden="{{unreadNotifications === 0 || unreadNotifications === null}}" matBadgeColor="warn"
          matBadgeSize="small" class="clickeable opt" aria-hidden="false" (click)="obtenerNotifications($event);">
          notifications_none
        </mat-icon>
      </div>

      <div class="col" *ngIf="puedeCambiarRol()">
        <mat-icon class="opt" matTooltip="Cambiar de Rol" (click)="alternarRolPropio()">
          compare_arrows
        </mat-icon>
      </div>

      <div class="col">
        <mat-icon class="opt" matTooltip="Cerrar Sesión" (click)="logout()">
          power_settings_new
        </mat-icon>
      </div>

      <mat-icon class="close-notificacion" matTooltip="Cerrar Notificaciones" (click)="closeNotificationWrap()"
        [ngClass]="notificationSwitch ? 'd-block' : 'd-none'">
        highlight_off
      </mat-icon>
      <div id="notificationsWrap" [ngClass]="notificationSwitch ? 'd-block' : 'd-none'"
        (clickOutside)="closeNotificationWrap()">

        <h6 class="text-left">Notificaciones</h6>
        <hr />
        <ul>
          <li *ngFor="let item of notifications | slice:0:15;" [ngClass]="item?.fecha_lectura ? 'leida' : 'no-leida'"
            [class.notificacionConEnlace]="tieneEnlace(item)"
            [attr.role]="tieneEnlace(item) ? 'link' : null"
            [attr.tabindex]="tieneEnlace(item) ? 0 : null"
            [attr.aria-label]="tieneEnlace(item) ? item.mensaje + ' (abrir)' : null"
            (click)="abrirNotificacion(item, $event)"
            (keydown.enter)="abrirNotificacion(item, $event)">
            <small>{{item?.created_at | date:'dd/MM/yyyy - hh:mm a'}}</small><br>
            <span>{{item?.mensaje}}</span>
            <mat-icon *ngIf="tieneEnlace(item)" class="iconoEnlace" aria-hidden="true">arrow_forward</mat-icon>
          </li>
          <li>
            <span class="no-more-notf">No hay más notificaciones...</span>
          </li>
        </ul>
      </div>

    </div>
  </div>

  <div class="side-menu-nav">
    <mat-accordion [displayMode]="'flat'">
      <mat-expansion-panel [expanded]="categoryIsActive('/solicitudes')" *ngIf="canSeeCategory('solicitudes')">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
          <mat-panel-title>
            <mat-icon class="expand-icon" [inline]="true">list_alt</mat-icon>
            Solicitudes
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item [routerLink]="['/solicitudes']" [class.active]="itemIsActive('/solicitudes')">
            <mat-icon matListItemIcon>vertical_split</mat-icon>
            <span matListItemTitle>Ver Solicitudes</span>
          </mat-list-item>
          <mat-list-item *ngIf="esAdministrador()" [routerLink]="['/solicitudes/reporte-logistica']"
            [class.active]="itemIsActive('/solicitudes/reporte-logistica')">
            <mat-icon matListItemIcon>assessment</mat-icon>
            <span matListItemTitle>Reporte Logística</span>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="categoryIsActive('/riego')" *ngIf="canSeeCategory('riego')">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
          <mat-panel-title>
            <mat-icon class="expand-icon" [inline]="true">spa</mat-icon>
            Riego
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item [routerLink]="['/riego/dashboard']" [class.active]="itemIsActive('/riego/dashboard')">
            <mat-icon matListItemIcon>dashboard</mat-icon>
            <span matListItemTitle>Dashboard</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/riego/opriego']" [class.active]="itemIsActive('/riego/opriego')">
            <mat-icon matListItemIcon>playlist_add_check</mat-icon>
            <span matListItemTitle>Operaciones de Riego</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/riego/bpyr']" [class.active]="itemIsActive('/riego/bpyr')">
            <mat-icon matListItemIcon>opacity</mat-icon>
            <span matListItemTitle>Bombas, Pozos y Represas</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/riego/lotes']" [class.active]="itemIsActive('/riego/lotes')">
            <mat-icon matListItemIcon>map</mat-icon>
            <span matListItemTitle>Campos, Lotes y Cuadros</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/riego/fertilizacion']" [class.active]="itemIsActive('/riego/fertilizacion')">
            <mat-icon matListItemIcon>invert_colors</mat-icon>
            <span matListItemTitle>Fertilización</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/riego/fertilizantes']" [class.active]="itemIsActive('/riego/fertilizantes')">
            <mat-icon matListItemIcon>science</mat-icon>
            <span matListItemTitle>Fertilizantes</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/riego/regadores']" [class.active]="itemIsActive('/riego/regadores')">
            <mat-icon matListItemIcon>people</mat-icon>
            <span matListItemTitle>Permisos para Regadores</span>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="categoryIsActive('/chat-ia')" *ngIf="canSeeCategory('chat-ia') && (chatIaHabilitado$ | async)">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
          <mat-panel-title>
            <mat-icon class="expand-icon" [inline]="true">chat</mat-icon>
            Asistente
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item [routerLink]="['/chat-ia']" [class.active]="itemIsActive('/chat-ia')">
            <mat-icon matListItemIcon>smart_toy</mat-icon>
            <span matListItemTitle>Chat IA</span>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="categoryIsActive('/configuracion')" *ngIf="canSeeCategory('configuracion')">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
          <mat-panel-title>
            <mat-icon class="expand-icon" [inline]="true">settings</mat-icon>
            Configuración
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-list>
          <mat-list-item [routerLink]="['/configuracion/insumos']"
            [class.active]="itemIsActive('/configuracion/insumos')">
            <mat-icon matListItemIcon>shopping_cart</mat-icon>
            <span matListItemTitle>Configurar Insumos</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/configuracion/usuarios']"
            [class.active]="itemIsActive('/configuracion/usuarios')">
            <mat-icon matListItemIcon>people</mat-icon>
            <span matListItemTitle>Configurar Usuarios</span>
          </mat-list-item>
          <mat-list-item [routerLink]="['/configuracion/destinos']"
            [class.active]="itemIsActive('/configuracion/destinos')">
            <mat-icon matListItemIcon>location_on</mat-icon>
            <span matListItemTitle>Configurar Destinos</span>
          </mat-list-item>
        </mat-list>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="boton-que-hay-de-nuevo">
    <i class="material-icons" (click)="abrirNoticias()">
      info
    </i>
  </div>
</div>